
<template>

  <div :class="`range-node ${parseClass()}-node`">
    <input
      type="range"
      :min="min + index"
      :max="max"
      v-model="range.min"
      v-if="includesSlider()"
    >
    <!-- <h6>{{stdUnits(range.min)}} - {{stdUnits(range.max)}}{{switchUnits()}}</h6> -->
    <!-- <h6 v-if="!(!$store.state.user.metric && val === 'ttp')">{{range.min}} - {{range.max}}{{switchUnits()}}</h6> -->

    <!-- <h6 v-else>{{setStandard(range.min)}} - {{setStandard(range.max)}}{{switchUnits()}}</h6> -->

    <!-- <input
      type="range"
      :min="calcFahr(min) + index"
      :max="calcFahr(max)"
      v-model="calcFahr(range.min)"
      v-if="$store.state.user.metric && val === 'ttp'"
    > -->

    <h6>{{langTitle(title)}}</h6>
    <h6 v-if="!['voc', 'deltaPressure95Percentile'].includes(val)">{{range.min}} ~ {{newSlide ? max - 1 : max}}{{switchUnits()}}</h6>
    <h6 v-if="val == 'voc'">{{(range.min/1000).toFixed(3)}} ~ {{(max/1000).toFixed(3)}}</h6>
    <h6 v-if="val == 'deltaPressure95Percentile'">
      {{this.$store.state.user.pressure ? range.min : (range.min / 249.082).toFixed(2)}}
        ~ {{this.$store.state.user.pressure ? max : (max / 249.082).toFixed(2)}}</h6>

    <!-- <h6>{{range.min}}<span v-if="includesSlider()"> ~ {{max}}</span>{{switchUnits()}}</h6> -->

    <!-- <h6 v-if="$store.state.user.metric && val === 'ttp'">{{calcFahr(range.min)}} - {{calcFahr(range.max)}}</h6> -->

  </div>

</template>

<script>

import cToF from 'celsius-to-fahrenheit';

import Lang from '@/lib/langTemplates/CardTemplate';

export default {

  data(){
    return {
      setMin: -1
    }
  },

  props: ['range', 'min', 'max', 'tier', 'title', 'val', 'index', 'newSlide'],

  computed: {
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    }
  },

  methods: {

    parseClass(){
      if (this.tier === 'good') {
        return 'good';
      } else {
        return this.tier === 'crit2' || this.tier === 'crit' ? 'crit' : 'warn'
      }
    },

    includesSlider(){
      if (['hhm', 'ttp'].includes(this.val)) {
        if (['crit2'].includes(this.tier)) {
          return false;
        } else {
          return true;
        }
      } else if (['iaq', 'co2', 'voc', 'deltaPressure95Percentile'].includes(this.val)) {
        return this.tier === 'good' ? false : true;
      } else {
        return this.tier === 'crit' ? false : true;
      }
    },

    stdUnits(n){
      if (this.val === 'ttp') {
        return this.$store.state.user.metric ? n : Math.round(cToF(n));
      } else {
        return n;
      }
    },

    switchUnits(){
      switch (this.val) {
        case 'days':
          return ' ' + this.clauses.days;
        break;
        case 'ttp':
          // return '˚C';
          return this.$store.state.user.metric ? '˚C' : '˚F';
        break;
        case 'hhm':
          return ' %';
        break;
        case 'iaq':
          return '';
        break;
        case 'co2':
          return ' ppm';
        break;
        case 'deltaPressure95Percentile':
          return this.$store.state.user.pressure ? 'Pa' : 'iwg';
      }
    },

    setStandard(val){
      return Math.round(cToF(parseInt(val)));
    },

    langTitle(t){
      switch (t) {
        case 'Good':
          return this.clauses.good;
        break;
        case 'Warning':
          return this.clauses.warning;
        break;
        case 'Critical':
          return this.clauses.critical;
        break;
        case 'Warning High':
          return this.clauses.warnHigh;
        break;
        case 'Critical High':
          return this.clauses.critHigh;
        break;
        case 'Warning Low':
          return this.clauses.warnLow;
        break;
        case 'Critical Low':
          return this.clauses.critLow;
        break;
      }
    },

    calcFahr(n){
      return Math.round(cToF(n));
    }

  },

  mounted(){
    if (this.val == 'deltaPressure95Percentile') console.log(this.range);
  },

  watch: {
    'range.min': function(newData, oldData){
      this.$emit('updateRange', {tier: this.tier, newValue: parseInt(this.range.min), val: this.val});
    },
    max: function(newData, oldData){
      if (newData <= this.range.min) {
        this.range.min = newData - 1;
      }
    }
  }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/setpoints/Slider.vue